module.exports = __webpack_public_path__ + "img/privacy_en.c072b57.jpg";